import * as React from "react";

import "./Icon.css";

const SvgClientIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 48 48"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon shake-two-icon-target ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <g transform="translate(0,1)">
      <path d="M34.15 23.05a12.77 12.77 0 0 1-20.3 0A22.92 22.92 0 0 0 0 43.85h48a22.92 22.92 0 0 0-13.85-20.8" />
      <circle cx={24} cy={11} r={11} />{" "}
    </g>
  </svg>
);
export default SvgClientIcon;
